import { render, staticRenderFns } from "./PdfConferma.vue?vue&type=template&id=6dd30145&scoped=true&"
import script from "./PdfConferma.vue?vue&type=script&lang=js&"
export * from "./PdfConferma.vue?vue&type=script&lang=js&"
import style0 from "./PdfConferma.vue?vue&type=style&index=0&id=6dd30145&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd30145",
  null
  
)

export default component.exports